var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuxury(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14.9833333px",
    height: "16.025px",
    viewBox: "0 0 14.9833333 16.025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Large/Jewelry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotelcard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ThemaBadge/Round/Luxury",
    transform: "translate(-9.333333, -8.308333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Large/Jewelry",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.589375,2.5 L11.875,4.58333333 L10.5104167,6.82395833 C13.0839583,7.43104167 15,9.74104167 15,12.5 C15,15.7216667 12.3883333,18.3333333 9.16666667,18.3333333 C5.945,18.3333333 3.33333333,15.7216667 3.33333333,12.5 C3.33333333,9.75583333 5.22854167,7.455625 7.78104167,6.83354167 L6.93520833,5.44458333 L10.2083333,4.58333333 L6.41083333,4.58333333 L7.69645833,2.5 L10.589375,2.5 Z M9.16666667,7.6875 C6.50875,7.6875 4.35416667,9.84208333 4.35416667,12.5 C4.35416667,15.1579167 6.50875,17.3125 9.16666667,17.3125 C11.8245833,17.3125 13.9791667,15.1579167 13.9791667,12.5 C13.9791667,9.84208333 11.8245833,7.6875 9.16666667,7.6875 Z M16.0416667,2.30833333 C16.3960417,3.94166667 16.6833333,4.22895833 18.3166667,4.58333333 C16.6833333,4.93770833 16.3960417,5.225 16.0416667,6.85833333 C15.6872917,5.225 15.4,4.93770833 13.7666667,4.58333333 C15.4,4.22895833 15.6872917,3.94166667 16.0416667,2.30833333 Z",
    id: "Combined-Shape",
    fill: "#2800A0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuxury);
export default __webpack_public_path__ + "static/media/Luxury.8224e0982e70bd7ece2f46dbce194d4c.svg";
export { ForwardRef as ReactComponent };